import styled from "styled-components";
import { ModalHeader } from "../styles";

export const ModalConfirmationHeader = styled(ModalHeader)`
  border-bottom: solid 1px #dadde1;
`;
